module.exports = __webpack_public_path__ + "static/media/orange-check.d1cc3e18.svg";